import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import DstTable from "../../../../components/DstTable/DstTable";
import { getAbsenceStatusColor, getAbsenceStatusIcon } from "../../../../services/MeetingAbsenceStatus";
import { formatDateHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { completeNavigate } from "../../../../services/UtilityService";
import { fetchAbsenceProofs } from "./AbsenceProofs.function";

const AbsenceProofs = ({ meetingId, language }: { meetingId: string; language: string }) => {
  const navigate = useNavigate();
  const [proofs, setProofs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAbsenceProofs(meetingId, setProofs, setLoading, language);
  }, [meetingId, language]);

  const columns = [
    {
      key: "user.full_name",
      name: translate(language, "GLOBAL.NAME"),
      render: (item: any) => (
        <a href={`/user/${item.user.id}`} className="text-decoration-underline">
          {item.user.full_name}
        </a>
      ),
    },
    {
      key: "user.email",
      name: translate(language, "GLOBAL.EMAIL"),
    },
    {
      key: "dt_added",
      name: translate(language, "PAGES.MEETING.ABSENCE_PROOFS.COLUMN.SUBMISSION_DATE"),
      render: (item: any) => formatDateHumanly(language, item.dt_added, true),
    },
    {
      key: "dt_validated",
      name: translate(language, "PAGES.MEETING.ABSENCE_PROOFS.COLUMN.VALIDATION_DATE"),
      render: (item: any) => (item.status === "validated" ? formatDateHumanly(language, item.dt_validated, true) : "-"),
    },
    {
      key: "validator",
      name: translate(language, "PAGES.MEETING.ABSENCE_PROOFS.COLUMN.VALIDATOR"),
      render: (item: any) => (item.status === "validated" ? item.validator : "-"),
    },
    {
      key: "status",
      name: translate(language, "GLOBAL.STATUS"),
      render: (item: any) => (
        <span className={`d-flex align-items-center ${getAbsenceStatusColor(item.status)}`}>
          {getAbsenceStatusIcon(item.status)} {item.status.toUpperCase()}
        </span>
      ),
    },
  ];

  return (
    <DstTable
      columns={columns}
      data={proofs}
      loading={loading}
      pagination
      paginationResizeOptions={[5, 10, 20]}
      striped={false}
      classLine={(item: any) => (item.status !== "pending" ? "table-secondary" : "")}
      onRowClick={(event, item) =>
        completeNavigate(event, navigate, `/meetings/${meetingId}/absence-proofs/${item.user.id}`)
      }
    />
  );
};

export default AbsenceProofs;
